import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=6021a619&"
import script from "./NavItem.vue?vue&type=script&lang=js&"
export * from "./NavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6021a619')) {
      api.createRecord('6021a619', component.options)
    } else {
      api.reload('6021a619', component.options)
    }
    module.hot.accept("./NavItem.vue?vue&type=template&id=6021a619&", function () {
      api.rerender('6021a619', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/nav-card/NavItem.vue"
export default component.exports